import { gql, useQuery } from 'urql';
import { useCallback } from 'react';

export const PARTICIPANTS_QUERY = gql`
  query GetParticipants(
    $joinedAfter: FlexibleDateTime
    $joinedBefore: FlexibleDateTime
    $source: String
    $isRemote: Boolean
    $searchString: String
  ) {
    getParticipants(
      joinedAfter: $joinedAfter
      joinedBefore: $joinedBefore
      source: $source
      isRemote: $isRemote
      searchString: $searchString
    ) {
      participants {
        id
        email
        phone
        firstName
        lastName
        position
        joinedAt
        leftAt
        active
        source
        isRemote
      }
    }
  }
`;

export interface IUser {
  id: number;
  email: string;
  login: string;
  phone: string;
  firstName: string;
  lastName: string;
  position: string;
  checked?: boolean;
  joinedAt: string;
  leftAt: string | null;
  active: boolean;
  source: string;
  isRemote?: boolean;
}

export interface IUsersResponse {
  getParticipants: {
    participants: IUser[];
  };
}

interface GetParticipantsVariables {
  joinedAfter?: string;
  joinedBefore?: string;
  source?: string;
  isRemote?: boolean;
  searchString?: string;
}

export const useFetchUsers = (
  joinedAfter?: string,
  joinedBefore?: string,
  source?: string,
  isRemote?: boolean,
  searchString?: string,
  pause?: boolean
) => {
  const trimmedSearch = searchString?.trim();

  const [{ error, fetching, data }, executeQuery] = useQuery<IUsersResponse, GetParticipantsVariables>({
    query: PARTICIPANTS_QUERY,
    variables: {
      joinedAfter,
      joinedBefore,
      source,
      isRemote,
      searchString: trimmedSearch,
    },
    requestPolicy: 'network-only',
    pause,
  });

  const userData = data?.getParticipants && data.getParticipants;

  const refetch = useCallback(() => {
    executeQuery({ requestPolicy: 'network-only' });
  }, [executeQuery]);

  return { error, userData, fetching, refetch };
};
